import { useContext, useEffect, useState } from 'react';
import { AppBar, Box } from '@mui/material';
import { MainLayout } from './components/MainLayout';
import { SideMenu } from './components/SideMenu';
import { NavBarLayout } from './components/NavBarLayout';
import { styled } from '@mui/material/styles';
import { useUser } from '../../components/Auth/User';
import DrawerDesktop from './components/DrawerDesktopMenu';
import Loader from '../Loader/Loader';
import Toolbar from '@mui/material/Toolbar';
import { MenuStateContext } from '../context/MenuState/MenuStateContext';
import { useWidth } from '../../@iosper/utils/UseWidth';

export const DRAWER_WIDTH = 260;

const AppBarMenu = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        marginLeft: `${DRAWER_WIDTH}px`,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const isMobileWidth = (width) => {
  return width === 'xs' || width === 'sm' || width === 'md';
};

const Menu = (props) => {
  const { user } = useUser();
  const { open } = useContext(MenuStateContext);
  const [openMobile, setOpenMobile] = useState(false);
  const screenWidth = useWidth();
  const isMobile = isMobileWidth(screenWidth);

  const handleToggleMobile = () => {
    setOpenMobile(!openMobile);
  };

  if (!user) {
    return (
      <Box sx={{ display: 'flex' }}>
        <AppBar
          position='fixed'
          sx={{
            ml: { md: `${DRAWER_WIDTH}px` },
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Loader id='headerLoader' />
        </AppBar>
        <Box
          component='main'
          sx={{ flexGrow: 1, p: 3, width: { md: `calc(100% - ${DRAWER_WIDTH}px)` } }}
        >
          <Toolbar />
          {props.children}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      {isMobile && (
        <>
          <AppBarMenu position='fixed' open={openMobile}>
            <NavBarLayout open={openMobile} onToggleMenuMobile={handleToggleMobile} />
            <Loader id='headerLoader' />
          </AppBarMenu>

          <Box component='nav' sx={{ width: { md: DRAWER_WIDTH } }}>
            {/* <DrawerMobile open={openMobile} onClose={handleToggleMobile} container={container}>{drawer}</DrawerMobile> */}
            <DrawerDesktop open={openMobile}>
              <SideMenu />
            </DrawerDesktop>
          </Box>

          {/* Main sector */}
          <MainLayout open={openMobile}>
            <Toolbar />
            {props.children}
          </MainLayout>
        </>
      )}
      {!isMobile && (
        <>
          <AppBarMenu position='fixed' open={open}>
            <NavBarLayout open={open} />
            <Loader id='headerLoader' />
          </AppBarMenu>

          <Box component='nav' sx={{ width: { md: DRAWER_WIDTH } }}>
            {/* <DrawerMobile open={openMobile} onClose={handleToggleMobile} container={container}>{drawer}</DrawerMobile> */}
            <DrawerDesktop open={open}>
              <SideMenu />
            </DrawerDesktop>
          </Box>

          {/* Main sector */}
          <MainLayout open={open}>
            <Toolbar />
            {props.children}
          </MainLayout>
        </>
      )}
    </Box>
  );
};

export default Menu;
